import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import React from "react";
import Typography from "@material-ui/core/Typography";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    text: {
      "& > * ": {
        marginBottom: 10,
      },
    },
  })
);

function Hygiene({ renderButton }) {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();
  return (
    <>
      {renderButton(() => {
        setOpen(true);
      })}
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        scroll={"paper"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">Hygiene-Konzept</DialogTitle>
        <DialogContent dividers={true}>
          <DialogContentText
            id="scroll-dialog-description"
            tabIndex={-1}
            className={classes.text}
          >
            <Typography color="textSecondary">
              Mit deiner Buchung verpflichtest du dich, das im Aushang
              befindliche Hygiene- und Infektionsschutzkonzept für den o.g.
              Spieltag des Ausrichters (Heimmannschaft) einzuhalten und somit
              aktiv dazu beizutragen, das Risiko einer Infektion mit Covid-19
              für dich und deine Mitmenschen zu minimieren.
            </Typography>
            <Typography color="textSecondary">
              Eine Missachtung führt zum Ausschluss vom Spieltag.
            </Typography>
            <Typography color="textSecondary">
              Mit deiner Buchung bestätigst du, dass du die Verhaltens- und
              Hygieneregeln gelesen und verstanden hast.
            </Typography>
            <Typography color="textSecondary">
              Außerdem stimmst du zu, dass deine persönlichen Daten zum Zwecke
              der Kontaktaufnahme im Zusammenhang mit einer möglichen COVID-19-
              Infektion durch den Ausrichter genutzt und bis zu vier Wochen
              gespeichert werden dürfen.
            </Typography>
            <Typography color="textSecondary">
              Die Daten dürfen im Bedarfsfall auf Anfrage ebenfalls den
              zuständigen Behörden weitergegeben werden.
            </Typography>
            <Typography color="textSecondary">
              Nach Ablauf von vier Wochen bleiben die Daten solange erhalten,
              bis du dein Profil bei der Online-Registrierung löschst.
            </Typography>
            <Typography color="textSecondary">
              <b>Ansprechpartner:</b> <br />
              Philipp Heuermann
              <br />
              0157 53607434
              <br />
              p.heuermann@outlook.de
            </Typography>
            <Typography color="textSecondary">
              <b>Konzept gilt für:</b>
              <br />
              Schulzentrum Halle I, <br />
              Holtwicker Straße 8, <br />
              48653 Coesfeld
            </Typography>
            <Typography color="textSecondary">
              Max. 30 Personen (Spieler, Trainer, Schiedsrichter, Anschreiber)
              im Wettkampfbereich. Zuschauer dürfen sich zu keinem Zeitpunkt im
              Wettkampfbereich aufhalten und müssen den Mindestabstand von 1,5
              Meter zu den Aktiven einhalten (Abstand Tribüne –
              Wettkampfbereich).
            </Typography>
            <Typography color="textSecondary">
              Spieler und Schiedsrichter betreten die Sporthalle über den
              Spielereingang. Über diesen Weg verlassen auch alle Aktiven die
              Halle. Die Zuschauer betreten die Halle über den Zuschauereingang.
              Der Ausgang der Zuschauer ist separat gekennzeichnet. Die Plätze
              auf der Tribüne sind in mehrere Sektoren eingeteilt und
              platztechnisch gekennzeichnet, sodass der Mindestabstand von 1,5
              Meter ein zu halten ist. Auch der Weg zu den Sektoren ist
              markiert. Im gesamten Zuschauer-Bereich gilt MNS Pflicht bis zum
              Einnehmen des Platzes. Sowohl im Eingangsbereich, im Bereich der
              Cafeteria und an den Toiletten sind Desinfektionsspender
              angebracht.
            </Typography>
            <Typography color="textSecondary">
              Alle Teilnehmer sind verpflichtet bis zum Erreichen der
              Wettkampffläche einen Mundnasenschutz zu tragen.
            </Typography>
            <Typography color="textSecondary">
              Die Kontaktdaten aller Teilnehmenden, Helfer und Zuschauer sind in
              einer Liste umfassend zu erheben. Die Zuschauer haben die
              Möglichkeit über eine kostenpflichtige Ticketreservierung Ihre
              Daten bereits online unter sg-coes.web.app einzugeben. Im
              Eingangsbereich werden hinter einem Spuckschutz mögliche
              Rest-Tickets verkauft und die Daten vor Ort zur Nachverfolgung
              erfasst.
            </Typography>
            <Typography color="textSecondary">
              Insgesamt dürfen sich 130 Personen in der Halle aufhalten. Also
              100 Zuschauer inkl. Helfer im Zuschauerbereich.
            </Typography>
            <Typography color="textSecondary">
              Eine Cafeteria wird angeboten. Die Helfer tragen Mundnasenschutz.
              Der Bereich ist zusätzlich mit einem Spuckschutz separiert. Auch
              hier steht Handdesinfektion zur Verfügung.
            </Typography>
            <Typography color="textSecondary">
              Die Umkleiden sind nutzbar und werden jeder Mannschaft zugeteilt,
              auch hier sollte auf ausreichend Abstand geachtet werden. Zutritt
              nur für die max. 13 Personen, die sich später auch im
              Wettkampfbereich aufhalten.
            </Typography>
            <Typography color="textSecondary">
              Die Duschen sind ebenfalls geöffnet und dürfen mit 1,5 Meter
              Abstand von Person zu Person benutzt werden.
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
            }}
            color="primary"
          >
            Akzeptieren
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Hygiene;
